import type { PropertyJournalActorRef } from "@zplanem/responses"
import type { Translations } from "@zplanem/translations"

/**
 * Resolve the actor's display name for a journal event row.
 *
 * GDPR null-actor handling: when the API emits both `userId` and
 * `displayName` as `null` (after a hard delete cascaded the actor FK to
 * SET NULL), fall back to the localized "Deleted user" label. If the
 * snapshot is partially populated we still treat it as deleted — there
 * is no usable identifier to render to the viewer.
 */
export function resolveActor(
	actor: PropertyJournalActorRef,
	t: Translations,
): string {
	if (actor.displayName !== null) return actor.displayName
	return t.journal.deletedUser
}

/**
 * Minimal `{key}` placeholder interpolation used by journal event-row
 * components. Mirrors the existing `t.modalTitle.replace("{name}", ...)`
 * pattern but supports multiple placeholders in one call. Uses a global
 * regex so repeated placeholders in a single template are all swapped.
 */
export function interpolate(
	template: string,
	vars: Record<string, string>,
): string {
	return Object.entries(vars).reduce(
		(acc, [k, v]) => acc.split(`{${k}}`).join(v),
		template,
	)
}
